function formatValue(number: number): string{
    const newValue = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRl' }).format(number);

    return newValue;
}

export default formatValue;